import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { NEUTRAL } from "../../../../theme/tokens";
import type { GapsPickupBonuses } from "../gapsPickupBonuses";
import { GapsPickupBonusLine } from "./GapsPickupBonusLine";
import { METRIC_LABEL_SX } from "./gapsMetricsStyles";

type Props = { bonuses: GapsPickupBonuses };

/**
 * The Pick-up bonuses row (P3-11): what the day's open posts are offering, and what the day's staffed shifts were
 * promised — the second said to be already inside Total cost, because it is (the backend writes a shift's bonus into its
 * wage total, and only the shifts Total cost counts are summed). Building-wide like Total cost beside it: the saved
 * scope narrows neither.
 */
export const GapsPickupBonusesCell: FC<Props> = ({ bonuses }) => {
	const { t } = useTranslation();
	return (
		<Box
			data-testid="gaps-metrics-bonus"
			sx={{ gridColumn: "1 / -1", display: "flex", flexDirection: "column", gap: 0.5, pb: 0.625, borderBottom: `1px solid ${NEUTRAL[200]}` }}
		>
			<Typography component="span" sx={METRIC_LABEL_SX}>
				{t("gaps.bonus.label")}
			</Typography>
			<GapsPickupBonusLine lineKey="offered" label={t("gaps.bonus.offered")} hint={t("gaps.bonus.offeredHint")} amount={bonuses.offered} />
			<GapsPickupBonusLine lineKey="committed" label={t("gaps.bonus.committed")} hint={t("gaps.bonus.committedHint")} amount={bonuses.committed} />
		</Box>
	);
};
